/**
 * Tab Folder
 */
export class TabFolder {
    constructor() {
        this.items = [];
    }
    /**
     * Adds tab item
     * @param item
     */
    addItem(item) {
        item.setTabFolder(this);
        item.setTabIndex(this.items.length);
        this.items.push(item);
    }
    /**
     * set Active tab item
     * @param index index
     */
    setActive(index) {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].setActive(i === index);
        }
    }
}
//# sourceMappingURL=TabFolder.js.map